import Unavailable from 'components/_pages/booking/Form/Unavailable';
import dayjs from 'dayjs';
import i18n from 'providers/Locale';
import { BlockedTime, BookingSettings, WorkTimeType } from 'shared/types';

import { WideSelectOption } from '../../../../components/_pages/booking/Form/WideSelect';
import { dayLabel } from '../../format';
import getNearestBusinessDay from '../../schedule/getNearestBusinessDay';

type Props = {
	workTimeAll: WorkTimeType[];
	bookingSettings: BookingSettings;
	blockedTimes?: BlockedTime[];
};

const MAX_DAYS = 90;

/**
 * Get booking available days based on place workTimeAll, booking exceptions and blocked times
 **/
const getDayOptions = ({ workTimeAll, bookingSettings, blockedTimes = [] }: Props) => {
	const options: WideSelectOption[] = [];

	if (!workTimeAll || !workTimeAll.length || !bookingSettings) return options;

	const { maxDaysBefore = MAX_DAYS, workingHours } = bookingSettings;
	const nearestBusinessDay = getNearestBusinessDay({
		workTimeAll,
		exceptions: workingHours?.exceptions,
		delay: bookingSettings.minIntervalBefore,
		useSameDayHack: true,
	});

	let startDate = dayjs(nearestBusinessDay);

	for (let i = 0; i < maxDaysBefore; i++) {
		const isDayAvailable = workTimeAll.find((d) => d.dayOfWeek === startDate.day())?.active;
		const label = dayLabel.getByDate(startDate.toDate());
		const value = startDate.format('YYYY-MM-DD');
		const isBlockedDay = blockedTimes.find((block) => block.date === value);
		const isExceptionDay = workingHours?.exceptions?.some((i) => i.date === value);

		if (isBlockedDay?.allDay && !isExceptionDay) {
			options.push({
				value,
				label,
				disabled: true,
				labelJSX: {
					left: label,
					right: (
						<Unavailable
							title={i18n('option_unavailable')}
							description={isBlockedDay.comment || ''}
						/>
					),
				},
			});
		} else if (isDayAvailable || isExceptionDay) {
			options.push({ value, label });
		} else {
			options.push({
				value,
				label,
				disabled: true,
				labelJSX: {
					left: label,
					right: (
						<span style={{ fontSize: '14px', fontWeight: '400' }}>{i18n('non_working_day')}</span>
					),
				},
			});
		}

		startDate = startDate.add(1, 'day');
	}

	return options;
};

export default getDayOptions;
